import * as Alert from "./reducers/Alert";
import * as Loading from "./reducers/Loading";
import * as Context from "./reducers/UserContext";
import * as DictionariesContext from "./reducers/DictionariesContext";

// The top-level state object
export interface ApplicationState {
  alerts: Alert.AlertState;
  loading: Loading.LoadingState;
  context: Context.UserContextState;
  dictionariesContext: DictionariesContext.DictionariesContextState;
}

// Whenever an action is dispatched, Redux will update each top-level application state property using
// the reducer with the matching name. It's important that the names match exactly, and that the reducer
// acts on the corresponding ApplicationState property type.
export const reducers = {
    alerts: Alert.reducer,
  loading: Loading.reducer,
  context: Context.reducer,
  dictionariesContext: DictionariesContext.reducer
};

// This type can be used as a hint on action creators so that its 'dispatch' and 'getState' params are
// correctly typed to match your store.
export interface AppThunkAction<TAction> {
    (dispatch: (action: TAction) => void, getState: () => ApplicationState): void;
}
